<template>
  <div class="fts-module">
    <template v-for="(x, ind) in displayMenus">
      <!-- module (group, menu) -->
      <div
        class="module-wrapper module-group"
        :class="{ open: x.open }"
        :style="moduleChild"
        :key="x.id"
        @click="openChildren(x)"
        @mouseover="onHover(x, true)"
        @mouseleave="onHover(x)"
        v-if="isGroup(x)"
      >
        <div class="module-info">
          <!-- emoji -->
          <fts-moji 
            :size="14" 
            :emoji="x.emoji" 
            class="module-emoji" 
            v-if="!!x.emoji"
          />
          <!-- name -->
          <fts-tippy
            trigger-class="module-name"
            :options="{ placement: 'top-start' }"
            :content="x.name"
            class="module-name-wrapper"
          >
            <template #trigger>{{x.name}}</template>
          </fts-tippy>
          <!-- profile -->
          <div class="module-tag" v-if="x.isProfile">
            <font-awesome-icon :icon="['fas', 'user']" fixed-width />
          </div>
        </div>
        <!-- actions -->
        <div class="module-action-container">
          <!-- design -->
          <fts-tippy content="Design" v-if="!workspaceBuilder && isAdminUser && !builderMode && mode != 'design' && x.module && isHovered(x)">
            <router-link :to="designRoute(x.module)" custom v-slot="{ href }">
              <fts-btn
                sm
                icon
                color="secondary"
                class="module-action stopPropagation"
                box-shadow-none
                tag="a"
                :href="href"
              >
                <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" />
              </fts-btn>
            </router-link>
          </fts-tippy>
          <!-- create -->
          <fts-tippy content="Create new entry" v-if="isCreatable(x.id) && mode != 'design' && isHovered(x)">
            <fts-btn
              sm
              icon
              color="primary"
              class="module-action stopPropagation"
              box-shadow-none
              @click="openCreateForm(x)"
            >
              <font-awesome-icon :icon="['fas', 'plus']" />
            </fts-btn>
          </fts-tippy>
        </div>
        <!-- toggle -->
        <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width class="module-toggle" />
      </div>
      <!-- custom (script) -->
      <div
        class="module-wrapper"
        :style="moduleChild"
        :key="x.id"
        @click="runScript(x)"
        v-else-if="x.script"
      >
        <div class="module-info">
          <!-- emoji -->
          <fts-moji 
            :size="14" 
            :emoji="x.emoji" 
            class="module-emoji" 
            v-if="!!x.emoji"
          />
          <!-- name -->
          <fts-tippy
            trigger-class="module-name"
            :options="{ placement: 'top-start' }"
            :content="x.name"
            class="module-name-wrapper"
          >
            <template #trigger>{{x.name}}</template>
          </fts-tippy>
        </div>
      </div>
      <!-- design mode -->
      <div
        class="module-wrapper"
        :style="moduleChild"
        :key="x.id"
        @mouseover="onHover(x, true)"
        @mouseleave="onHover(x, false)"
        v-else-if="mode == 'design'"
      >
        <div class="module-info">
          <!-- emoji -->
          <fts-emoji
            class="module-emoji"
            v-model="x.emoji"
            :append-to-body="true"
            :toggle-size="16"
            @click.prevent
          />
          <!-- name -->
          <fts-contenteditable class="module-contenteditable" v-model="x.name" @click.prevent />
        </div>
        <!-- actions -->
        <div class="module-action-container">
          <!-- design -->
          <fts-btn
            sm
            icon
            color="secondary"
            class="module-action stopPropagation"
            box-shadow-none
            @click="openListDesign(x)"
            v-if="isHovered(x) && action"
          >
            <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" />
          </fts-btn>
        </div>
      </div>
      <!-- module / menu -->
      <router-link
        :to="listViewRoute(x.id)"
        custom
        v-slot="{ navigate, href, route }"
        class="module-wrapper"
        :class="[
          {'module-wrapper--admin': x.id == 'everything'},
          {'active': isActive(x.id)}
        ]"
        :style="moduleChild"
        :key="x.id"
        @mouseover.native="onHover(x, true)"
        @mouseleave.native="onHover(x)"
        v-else
      >
        <a :href="href" @click.prevent="openListView(navigate, route)">
          <div class="module-info">
            <template v-if="x.id == 'everything'">
              <fts-moji 
                :size="14" 
                :emoji="x.emoji" 
                class="module-emoji" 
                v-if="!!x.emoji"
              />
              <fts-tippy
                trigger-class="module-name"
                :options="{ placement: 'top-start' }"
                content="For admin only"
                class="module-name-wrapper"
                v-if="x.id == 'everything'"
              >
                <template #trigger>{{x.name}}</template>
              </fts-tippy>
            </template>

            <template v-else>
              <fts-moji 
                :size="14" 
                :emoji="x.emoji" 
                class="module-emoji" 
                v-if="!!x.emoji"
              />
              <fts-tippy
                trigger-class="module-name"
                :options="{ placement: 'top-start' }"
                :content="x.name"
                class="module-name-wrapper"
              >
                <template #trigger>{{x.name}}</template>
              </fts-tippy>
            </template>

            <div class="module-tag" v-if="x.isProfile">
              <font-awesome-icon :icon="['fas', 'user']" fixed-width />
            </div>
          </div>
          <!-- actions -->
          <div class="module-action-container">
            <!-- design:module -->
            <fts-tippy content="Design" v-if="!workspaceBuilder && isAdminUser && !builderMode && mode != 'design' && x.module">
              <router-link
                :to="designRoute(x.module)"
                custom
                v-slot="{ navigate, href, route }"
                v-if="isHovered(x)"
              >
                <fts-btn
                  sm
                  icon
                  color="secondary"
                  class="module-action stopPropagation"
                  box-shadow-none
                  tag="a"
                  :href="href"
                  @click="navigate(route)"
                >
                  <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" />
                </fts-btn>
              </router-link>
            </fts-tippy>
            <!-- design:list -->
            <fts-tippy content="Design" v-else-if="!workspaceBuilder && parentId && isAdminUser && !builderMode && mode != 'design' && isHovered(x)">
              <router-link
                :to="designRoute(parentId, x.id)"
                custom
                v-slot="{ navigate, href, route }"
              >
                <fts-btn
                  sm
                  icon
                  color="secondary"
                  class="module-action stopPropagation"
                  box-shadow-none
                  tag="a"
                  :href="href"
                  @click="navigate(route)"
                >
                  <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" />
                </fts-btn>
              </router-link>
            </fts-tippy>
            <!-- create -->
            <fts-tippy content="Create new entry" v-if="isCreatable(x.id) && mode != 'design' && isHovered(x)">
              <fts-btn
                sm
                icon
                color="primary"
                class="module-action stopPropagation"
                box-shadow-none
                @click="openCreateForm(x)"
              >
                <font-awesome-icon :icon="['fas', 'plus']" />
              </fts-btn>
            </fts-tippy>
          </div>
        </a>
      </router-link>
      <!-- child -->
      <fts-module
        :mode="mode"
        child
        :workspace-builder="workspaceBuilder"
        :modules="x.children"
        :deep="deep + 1"
        :parent-id="getParentId(x)"
        v-if="x.open"
        :key="`${x.id || ind}-child`"
      />
    </template>
  </div>
</template>

<script>
import { authorizationStore } from '../store/authorizationStore';
import { clientStore } from '../store/clientStore';
import commons from '../commons/commons';
import { SYSTEM_CAPABILITY, isCapableOf } from '../commons/flags';

import FTSBtn from '../elements/FTSBtn';
import FTSContenteditable from '../elements/FTSContenteditable';
import FTSEmoji from '../elements/FTSEmoji';
import FTSMoji from '../elements/FTSMoji';
import FTSReleaseBadge from '../elements/FTSReleaseBadge';
import FTSTippy from '../elements/FTSTippy';

const getActionMessage = (evt, vm) => {
  if (
    evt.data &&
    (typeof evt.data === 'string' || evt.data instanceof String) &&
    evt.data.indexOf('inistate') > -1
  ) {
    try {
      const res = JSON.parse(evt.data);
      if (res.action === 'expandListing' && res.moduleId) {
        let menus = _.cloneDeep(vm.menus);
        commons.expandSidebarMenu(res.moduleId, menus);
        vm.menus = Object.assign([], vm.menus, menus);
      }
    } catch(err) { console.error(err); }
  }
}

export default {
  name: "fts-module",
  props: {
    mode: String,
    workspaceBuilder: Boolean,
    modules: Array,
    deep: {
      type: Number,
      default: 0,
    },
    child: Boolean,
    parentId: [String, Number],
    action: Boolean,
    filter: String
  },
  components: {
    "fts-btn": FTSBtn,
    "fts-contenteditable": FTSContenteditable,
    "fts-emoji": FTSEmoji,
    "fts-moji": FTSMoji,
    "fts-release-badge": FTSReleaseBadge,
    "fts-tippy": FTSTippy
  },
  data: () => ({
    filterUpdated: false,
    filterOpenMenuIds: [],
    hovered: null
  }),
  methods: {
    isCreatable(moduleId) {
      const modules = clientStore.state.workspaceModules;
      const module = modules.find(x => x.id == moduleId);
      return isCapableOf(SYSTEM_CAPABILITY.Write, modules, moduleId) && module && module.canCreate;
    },
    isGroup(x) {
      return (
        x.type === "group" ||
        (x.children && x.children.length && x.children[0].default !== true)
      );
    },
    isActive(itemId) {
      const currentTarget = this.parentId ? `${this.parentId}-${itemId}` : `${itemId}`;
      const target = this.list.id ? `${this.module.id}-${this.list.id}` : `${this.module.id}`;
      return currentTarget == target;
    },
    filterTree(items, tokens, forceOpen, parentPath) {
      const result = [];

      for (const item of items) {
        /* match each keyword against the whole ancestor path, so "inistate this year"
           finds Invoice (Inistate) > Sales (This Year) regardless of word order */
        const path = `${parentPath || ""} ${item.name || ""}`.toLowerCase();
        const selfMatch = tokens.every(token => path.includes(token));

        let filteredChildren = [];
        let isOpen = item.open;
        if (item.children && item.children.length) {
          filteredChildren = this.filterTree(item.children, tokens, forceOpen, path);
        }

        if (!selfMatch && !filteredChildren.length) continue;

        if (forceOpen) {
          isOpen = true;
          this.filterOpenMenuIds.push(item.id);
        } else if (this.filterOpenMenuIds.some(x => x == item.id)) {
          isOpen = true;
        }

        result.push({
          ...item,
          open: isOpen,
          children: selfMatch ? item.children : filteredChildren
        });
      }

      return result;
    },
    openChildren(x) {
      if (commons.elementStopPropagation()) return;

      const menus = _.cloneDeep(clientStore.state.workspace.menus);

      const findDeep = (items, id) => {
        for (const item of items) {
          if (item.id === id) return item;
          if (item.children) {
            const found = findDeep(item.children, id);
            if (found) return found;
          }
        }
        return null;
      };

      const target = findDeep(menus, x.id);
      if (!target) return;

      target.open = !x.open;
      this.filterOpenMenuIds = this.filterOpenMenuIds.filter(id => id != target.id);
      clientStore.dispatch("setWorkspaceMenus", menus);

      if (this.builderMode && target.type !== "group" && target.open) {
        this.$postEventMessage({ path: `/list/${commons.encodeids(target.id)}` });
      }
    },
    /* SS06415: the hovered row lives here, keyed by its id, not as a flag on the menu item. The workspace bootstrap
       replaces every menu object after the cached render, which wiped that flag under a still pointer and hid the
       row's + until the mouse left and came back. */
    hoverKey(x) {
      return x.id != null ? `id:${x.id}` : x;
    },
    isHovered(x) {
      return this.hovered != null && this.hovered === this.hoverKey(x);
    },
    onHover(x, visible) {
      const key = this.hoverKey(x);
      if (visible)
        this.hovered = key;
      else if (this.hovered === key)
        this.hovered = null;
    },
    runScript(x) {
      eval(x.script);
    },
    getParentId(x) {
      if (x.type !== "group") return x.id;
    },
    listViewRoute(x) {
      if (this.mode === "design")
        return;
      else if (this.parentId)
        return {
          name: 'list-view',
          params: { moduleId: commons.encodeids(this.parentId) },
          query: { l: x }
        }
      else
        return {
          name: 'list-view',
          params: { moduleId: commons.encodeids(x) }
        }
    },
    designRoute(moduleId, listId) {
      let route = {
        name: 'studio',
        query: { id: commons.encodeids(moduleId) }
      }

      if (listId)
        route.query = {
          ...route.query,
          t: 'menu',
          tid: listId
        }

      return route;
    },
    openListView(navigate, route) {
      if (commons.elementStopPropagation()) {
        return;
      } else {
        if (this.builderMode && route.fullPath === this.$route.fullPath) {
          this.$postEventMessage({path: route.fullPath});
        }
        navigate(route);
      }
    },
    openCreateForm(item) {
      if (this.$ftsDetailView) {
        window.eventBus.$emit("detailView:form", {
          moduleId: item.id,
          listingId: Array.isArray(item.children) && item.children[0] && item.children[0].id,
          activityId: "create"
        });
      } else {
        window.eventBus.$emit("quickViewData", {
          activityId: "create",
          vectorId: item.id,
        });
      }
    },
    openListDesign(x) {
      if (this.mode == "design") {
        this.hovered = null;
        this.$emit("list", x.id);
      }
    }
  },
  watch: {
    filter() {
      this.filterUpdated = true;
      this.filterOpenMenuIds = [];
    }
  },
  computed: {
    isAdminUser() {
      return authorizationStore.getters.isAdminUser;
    },
    displayMenus() {
      const base = this.menus;

      const tokens = (this.filter || "").toLowerCase().split(/\s+/).filter(Boolean);
      if (this.child || !tokens.length) {
        return base;
      }

      let forceOpen = false;
      if (this.filterUpdated) {
        forceOpen = true;
        this.filterUpdated = false;
      }

      return this.filterTree(base, tokens, forceOpen);
    },
    menus: {
      get() {
        return this.child ? this.modules : commons.visibleMenu(clientStore.state.workspace.menus);
      },
      set(val) {
        if (!this.child) {
          clientStore.dispatch("setWorkspaceMenus", val);
        }
      }
    },
    moduleChild() {
      return this.child && { 'padding-left': `${(this.deep * 20) + 8}px` };
    },
    module() {
      return clientStore.state.module || {};
    },
    moduleId() {
      return clientStore.getters.moduleId;
    },
    list() {
      return clientStore.state.list || {};
    },
  },
  created() {
    this.builderMode = commons.builderMode;
  },
  mounted() {
    /* [bridge] receive action message */
    if (!this.child && this.builderMode) {
      window.addEventListener("message", evt => getActionMessage(evt, this));
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", getActionMessage);
  }
};
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-module {
  .module-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 1px;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    padding: 5px 8px;
    border-radius: 0.25rem;
    text-decoration: unset;
    color: var(--drawer);
    cursor: pointer;
    .module-info {
      min-width: 0;
      flex: 1;
      display: flex;
      align-items: center;
      cursor: inherit;
      .module-emoji {
        margin-right: 0.375rem;
        line-height: 1.5;
        cursor: inherit;
      }
      .module-name-wrapper {
        min-width: 0;
        cursor: inherit;
        .module-name {
          @include text-overflow-ellipsis;
          font-size: 0.875rem;
          line-height: 1.5;
          cursor: inherit;
        }
      }
      .module-contenteditable {
        margin-right: 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
      }
      .module-tag {
        margin-left: 0.375rem;
        padding: 0.1rem 0.125rem;
        font-size: 0.625rem;
        border-radius: 0.25rem;
        background-color: var(--drawer-tag-background, var(--drawer-secondary-background));
        color: var(--drawer-tag, var(--drawer-secondary));
      }
    }
    .module-action-container {
      display: flex;
      position: absolute;
      right: 1.875rem;
      > *:not(:first-child) {
        margin-left: 0.375rem;
      }
      .module-action {
        &.fts-btn {
          height: 1.25rem;
          width: 1.25rem;
          min-height: 1.25rem;
          min-width: 1.25rem;
          border-radius: 0.25rem;
          font-size: 0.75rem;
          z-index: 1;
        }
      }
    }
    .module-toggle {
      margin-left: 0.5rem;
      font-size: 0.875rem;
      color: inherit;
      transition: all 0.3s;
    }
    &.module-group {
      &.open {
        .module-toggle {
          transform: rotate(90deg);
        }
      }
    }
    &:hover {
      background-color: var(--drawer-hover-background);
      color: var(--drawer-hover);
    }
    &.active {
      background-color: var(--drawer-active-background);
      color: var(--drawer-active);
    }
    &.module-wrapper--admin {
      color: var(--fts-secondary);
      &:hover,
      &.active {
        &::before {
          content: "";
          position: absolute;
          inset: 0;
          background-color: var(--fts-card-background);
          border-radius: inherit;
          z-index: -1;
        }
      }
      &:hover {
        background-color: rgba(var(--fts-secondary-rgb), 0.09);
      }
      &.active {
        background-color: rgba(var(--fts-secondary-rgb), 0.18);
      }
    }
  }
}
</style>